/* eslint-disable @next/next/no-img-element */
import React, { useContext } from 'react';

import HeaderWithCTA from '@components/header-with-cta';
import AppLayout from '@layouts/AppLayout';
import { StateContext } from '@store/store';
import HomepageSEO from '@components/common/SEO/HomepageSEO';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

function ConvertTwitterThreadToVideos() {
  const globalState = useContext(StateContext);
  const { platform, os, config } = globalState;

  return (
    <AppLayout platform={platform}>
      <HomepageSEO
        seo={{
          Title: 'Twitter Threads | invideo',
          Description:
            'Easily convert your twitter threads into videos with 3-easy steps using invideo.io',
          CanonicalURL: 'https://invideo.io/',
          Keywords: '',
          Hreflang: [],
          Meta: [],
          id: 0,
          RobotIndex: null,
          RobotFollow: null,
        }}
      />

      <HeaderWithCTA />
      <main
        className={ivclass(
          'iv-w-full iv-bg-no-repeat iv-bg-cover iv-bg-center',
        )}
        style={{
          minHeight: 'calc(100vh - 56px)',
          background: 'linear-gradient(to right, #aeaccb, #eaeaf2)',
        }}
      >
        <div className="iv-container iv-mx-auto iv-pt-20">
          <div></div>
          <div className="iv-flex iv-justify-between iv-flex-row md:iv-flex-col sm:iv-flex-col iv-flex-wrap iv-mx-40 sm:iv-mx-20 iv-mt-50">
            <div className="iv-w-2/5 md:iv-w-full sm:iv-w-full">
              <div className="landing-content">
                <div className="head iv-mx-2">
                  <h1 className="iv-text-heading-2xs iv-font-bold">
                    Convert your twitter threads into videos
                  </h1>
                </div>
                <div className="iv-row iv-mt-6 iv-p-15">
                  <div className="step-content iv-flex iv-items-center iv-justify-between">
                    <div className="step-no iv-text-center iv-mx-2 iv-w-[100px]">
                      <p className="text-brandPrimary iv-uppercase iv-text-sm">
                        Step 1
                      </p>
                    </div>
                    <div className="step-info iv-w-[480px] iv-bg-grey-0 iv-rounded-10 iv-max-w-full iv-px-15 iv-py-10">
                      <p className="iv-font-medium">
                        Select your thread on twitter &amp; go to the topmost
                        tweet of that thread.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="iv-row iv-p-15">
                  <div className="step-content iv-flex iv-items-center iv-justify-between">
                    <div className="step-no iv-text-center iv-mx-2 iv-w-[100px]">
                      <p className="text-brandPrimary iv-uppercase iv-text-sm">
                        Step 2
                      </p>
                    </div>
                    <div className="step-info iv-w-[480px] iv-bg-grey-0 iv-rounded-10 iv-max-w-full iv-px-15 iv-py-10 iv-ml-5">
                      <p className="iv-font-medium">
                        Tag us with @InVideoOfficial &amp; add keywords
                        &quot;thread invideo&quot;
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row iv-p-15">
                  <div className="step-content iv-flex iv-items-center iv-justify-between">
                    <div className="step-no iv-text-center iv-mx-2 iv-w-[100px]">
                      <p className="text-brandPrimary iv-uppercase iv-text-sm">
                        Step 3
                      </p>
                    </div>
                    <div className="step-info iv-w-[480px] iv-bg-grey-0 iv-rounded-10 iv-max-w-full iv-px-15 iv-py-10">
                      <p className="iv-font-medium">
                        You will receive your twitter thread video in that same
                        comment below. Share it.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="iv-m-20">
              <div className="landing-img">
                <img
                  className="img-responsive"
                  src="https://assets-static.invideo.io/static-assets/images/twitter-illustrations.png"
                  alt="Twitter Illustrations"
                />
              </div>
            </div>
          </div>
          <div className="landing-page-bottom iv-text-center iv-text-heading-4xs iv-font-semibold iv-mt-20 iv-pb-20">
            <p>See How People Have Used This Feature…</p>
          </div>
        </div>
      </main>
    </AppLayout>
  );
}

export default ConvertTwitterThreadToVideos;
